<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              append-icon="search"
              placeholder="Search by tag name"
              single-line
              hide-details
              @input="filter"
            />
            <v-spacer /><v-spacer />            
            <setup-tags-dialog-create @created="loadTags" />
          </v-toolbar>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="filteredTags"
            :sort-by.sync="sortBy"
            :items-per-page="itemsPerPage"
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td>{{ props.item.name }}</td>                
                <td>
                  <setup-tags-dialog-edit 
                    :tag="props.item"
                    @updated="loadTags"
                  />  
                  <setup-tags-dialog-delete 
                    :tag="props.item"
                    @deleted="loadTags"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTagsDialogCreate: () => import('@/components/setup/tags/DialogCreate'),
      SetupTagsDialogEdit: () => import('@/components/setup/tags/DialogEdit'),
      SetupTagsDialogDelete: () => import('@/components/setup/tags/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Setup - Tags',
      }
    },
    data () {
      return {
        loading: false,
        tags: [],
        tagFilter: '',
        headers: [
          {
            text: 'No',
            align: 'left',
            sortable: false,
            value: '',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            align: 'center',
            sortable: false,
            value: '',
          },
        ],
        sortBy: 'name',
        itemsPerPage: 10,
      }
    },
    computed: {
      filteredTags () {
        return this.tags.filter(tag => {
          return tag.name.toLowerCase().includes(this.tagFilter.toLowerCase())
        })
      },
    },
    created () {
      this.loadTags()
    },
    methods: {
      loadTags () {
        this.loading = true 

        this.$api.tags().list()
          .then(response => {
            this.tags = response.data

            this.loading = false
          })    
      },
      filter (val) {
        this.tagFilter = val
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }
</style>
